// src/components/ofertas/OfertasActions.jsx
import { Dropdown, DropdownButton, Button } from "react-bootstrap";
import { FaCheck, FaMagic } from "react-icons/fa";
import { MdDownload } from "react-icons/md";
import { LuFiles, LuClipboardList } from "react-icons/lu";

export default function OfertasListActions({
    oferta,
    userHasAgents,
    onAceptar,
    onImprimirContrato,
    onGestionArchivos,
    onVerNotas,
    onEnviarSignaturit, // abre el modal
    onSyncRenovacion,
    onRelanzar,
    onCancelar,
}) {
    const canAct = oferta.state === "Solicitud oferta" || oferta.state === "Contrato enviado";
    const canCancel = oferta.state === "Solicitud oferta" || oferta.state === "Contrato enviado";
    const canRelaunch = oferta.state === "Rechazada sol. ATR";



    return (
        <div className="d-flex flex-wrap gap-2">
            {canAct && (
                <>
                    <Button
                        variant="success"
                        size="sm"
                        className="rounded-pill px-3 fw-bold shadow-sm d-flex align-items-center gap-2"
                        onClick={() => onAceptar(oferta.id, oferta.sector_type)}
                    >
                        <FaCheck /> Aceptar
                    </Button>

                    <Button
                        variant="primary"
                        size="sm"
                        className="rounded-pill px-3 fw-bold shadow-sm d-flex align-items-center gap-2"
                        onClick={() => onImprimirContrato(oferta.user_id, oferta.id, oferta.polissa_id?.[0])}
                    >
                        <MdDownload /> Contrato
                    </Button>

                    <Button
                        variant="info"
                        size="sm"
                        className="rounded-pill px-3 fw-bold shadow-sm d-flex align-items-center gap-2 text-white"
                        onClick={() => onEnviarSignaturit(oferta)}
                    >
                        <MdDownload /> Signaturit
                    </Button>
                </>
            )}

            {oferta.type === 'renovacion' && onSyncRenovacion && (
                <Button
                    variant="outline-secondary"
                    size="sm"
                    className="rounded-pill px-3 fw-bold shadow-sm d-flex align-items-center gap-2"
                    onClick={() => onSyncRenovacion(oferta.id)}
                    title="Validar automáticamente datos de renovación"
                >
                    <FaMagic /> Validar Renovación
                </Button>
            )}

            {canRelaunch && onRelanzar && (
                <Button
                    variant="warning"
                    size="sm"
                    className="rounded-pill px-3 fw-bold shadow-sm d-flex align-items-center gap-2"
                    onClick={() => onRelanzar(oferta)}
                >
                    Relanzar oferta
                </Button>
            )}

            {canCancel && onCancelar && (
                <Button
                    variant="outline-danger"
                    size="sm"
                    className="rounded-pill px-3 fw-bold shadow-sm d-flex align-items-center gap-2"
                    onClick={() => onCancelar(oferta)}
                >
                    Cancelar
                </Button>
            )}

            <Button
                variant="light"
                size="sm"
                className="rounded-pill px-3 fw-bold shadow-sm border d-flex align-items-center gap-2"
                onClick={() => onGestionArchivos(oferta.id, oferta.name)}
            >
                <LuFiles /> Archivos
            </Button>

            <Button
                variant="light"
                size="sm"
                className="rounded-pill px-3 fw-bold shadow-sm border d-flex align-items-center gap-2"
                onClick={() => onVerNotas(oferta.id, oferta.name)}
            >
                <LuClipboardList /> Notas
            </Button>
        </div>
    );
}
